export default "__VITE_ASSET__aQOq0iWm__"